module.exports = __webpack_public_path__ + "img/play.e7f4c34a.svg";